<template>
  <div>
    <form novalidate @submit.prevent="salvar()">
      <ToolbarCadastro />
      <br />
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div
            :class="{
              'panel-primary': !v$.cid.$error,
              'panel-danger': v$.cid.$error,
            }"
            class="panel"
          >
            <div class="panel-heading">CID</div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                  <div
                    :class="{ 'has-error': v$.cid.descricaoAbreviada.$error }"
                    class="form-group"
                  >
                    <label>Descrição Abreviada <sup>(1)</sup></label>
                    <input
                      id="descricaoAbreviada"
                      v-model="cid.descricaoAbreviada"
                      data-test-id="input-descricaoabreviada"
                      type="text"
                      name="descricaoAbreviada"
                      class="form-control"
                      readonly
                      @input="v$.cid.descricaoAbreviada.$touch()"
                    />
                    <span v-if="v$.cid.descricaoAbreviada.$dirty">
                      <span
                        v-if="!v$.cid.descricaoAbreviada.required"
                        class="help-block"
                      >
                        Campo obrigatório.
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                  <div class="form-group">
                    <label>Situação</label>
                    <select
                      id="ativo"
                      v-model="cid.ativo"
                      data-test-id="select-ativo"
                      name="ativo"
                      class="form-control"
                    >
                      <option :value="true">Ativo</option>
                      <option :value="false">Cancelado</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div
                    :class="{ 'has-error': v$.cid.descricao.$error }"
                    class="form-group"
                  >
                    <label>Descrição <sup>(1)</sup></label>
                    <input
                      id="descricao"
                      v-model="cid.descricao"
                      data-test-id="input-descricao"
                      type="text"
                      name="descricao"
                      class="form-control"
                      readonly
                      @input="v$.cid.descricao.$touch()"
                    />
                    <span v-if="v$.cid.descricao.$dirty">
                      <span
                        v-if="!v$.cid.descricao.required"
                        class="help-block"
                      >
                        Campo obrigatório.
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>(1) Campos obrigatórios.</p>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import ToolbarCadastro from '@/componentes/ToolbarCadastro'
import { useMenu } from '@/composables/useMenu'
import router from '@/router'
import CidServico from '@/servicos/CidServico'
import MensagemServico from '@/servicos/MensagemServico'

const cidServico = new CidServico()
const mensagemServico = new MensagemServico()

const menuAtual = {
  descricao: 'Cadastro de CID',
  breadcrumb: ['Administrativo', 'Código CID', 'Cadastro de CID'],
}

export default {
  components: { ToolbarCadastro },
  setup() {
    useMenu(menuAtual)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      cid: {
        descricaoAbreviada: '',
        descricao: '',
        ativo: true,
      },
    }
  },
  validations: {
    cid: {
      descricaoAbreviada: { required },
      descricao: { required },
    },
  },
  created() {
    this.recuperarCid()
  },
  methods: {
    salvar() {
      this.v$.$touch()

      if (this.v$.cid.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (this.cid._id) {
          cidServico.atualizar(this.cid._id, this.cid).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Cid' })
          })
        } else {
          cidServico.criar(this.cid).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Cid' })
          })
        }
      }
    },
    recuperarCid() {
      const id = this.$route.params.id

      if (id) {
        cidServico.recuperar(id).then((result) => {
          this.cid._id = id
          this.cid.descricaoAbreviada = result.cid.descricaoAbreviada
          this.cid.descricao = result.cid.descricao
          this.cid.ativo = result.cid.ativo
        })
      }
    },
  },
}
</script>
